import { Color } from './types';

export const colors = {
    action: {
        primary: {
            base: '#4D86EC' as Color,
            hover: '#4A73BA' as Color,
            pressed: '#004B7A' as Color,
            disabled: '#EAECEF' as Color,
        },
        secondary: {
            base: '#FFFFFF' as Color,
            hover: '#F6F7F8' as Color,
            pressed: '#EEF0F2' as Color,
            disabled: '#F6F7F8' as Color,
        },
    },
    background: {
        primary: {
            base: '#FFFFFF' as Color,
            hover: '#E4EDFC' as Color,
        },
        secondary: {
            base: '#F6F7F8' as Color,
        },
        tertiary: {
            base: '#EEF0F2' as Color,
        },
        dark: {
            base: '#4472C4' as Color,
        },
    },
    content: {
        primary: {
            base: '#212832' as Color,
        },
        secondary: {
            base: '#4C5560' as Color,
        },
        tertiary: {
            base: '#9CA8B5' as Color,
        },
        prefilled: {
            base: '#9ca8b5' as Color,
        },
        placeholder: {
            base: '#B8C1CA' as Color,
        },
    },
    border: {
        primary: '#B8C1CA' as Color,
        secondary: '#D4D9DF' as Color,
        tertiary: '#EAECEF' as Color,
    },
    alert: {
        error: {
            content: '#E23E57' as Color,
            background: '#FDF0EF' as Color,
        },
        warning: {
            content: '#FFCB0A' as Color,
            background: '#FEF1C1' as Color,
        },
        success: {
            content: '#00CB84' as Color,
            background: '#F3FCF0' as Color,
        },
        info: {
            content: '#4D86EC' as Color,
            background: '#E4EDFC' as Color,
        },
    },
    navigation: {
        background: {
            primary: {
                base: '#1d4488' as Color,
                hover: '#4d86ec' as Color,
            },
            secondary: {
                base: '#4472c4' as Color,
                hover: '#4d86ec' as Color,
            },
        },
        content: {
            primary: {
                base: '#FFFFFF' as Color,
            },
        },
        border: {
            primary: '#4472c4' as Color,
        },
    },
} as const;
